export type ThemeMode = 'light' | 'dark';

export interface StudioThemeTokens {
  primary: {
    main: string;
    light: string;
    dark: string;
    contrastText: string;
  };
  secondary: {
    main: string;
    light: string;
    dark: string;
    contrastText: string;
  };
  background: {
    default: string;
    paper: string;
  };
  text: {
    primary: string;
    secondary: string;
  };
  border: string;
  ring: string;
  sidebar: {
    background: string;
    foreground: string;
    primary: string;
    primaryForeground: string;
    accent: string;
    accentForeground: string;
    border: string;
    ring: string;
  };
  buttonPrimaryHover:{
    main:string;
  };
  action: {
    disabled: string;
    disabledBackground: string;
  }
}

const lightTokens: StudioThemeTokens = {
  primary: {
    main: '#003366',
    light: '#194d80',
    dark: '#001a33',
    contrastText: '#fafafa',
  },
  secondary: {
    main: '#f2f2f2',
    light: '#f2f2f2',
    dark: '#cccccc',
    contrastText: '#3d4d5c',
  },
  background: {
    default: '#f2f2f2',
    paper: '#ffffff',
  },
  text: {
    primary: '#6c7f93',
    secondary: '#2e394d',
  },
  border: '#dedede',
  ring: '#008080',
  sidebar: {
    background: '#0c1f31',
    foreground: '#d6deeb',
    primary: '#008080',
    primaryForeground: '#fafafa',
    accent: '#14365c',
    accentForeground: '#f2f5f9',
    border: '#1a3a5d',
    ring: '#00a3a3',
  },
  buttonPrimaryHover:{
    main:'#008080'
  },
  action: {
    disabled: '#787878',
    disabledBackground: '#f2f2f2',
  }
};

const darkTokens: StudioThemeTokens = {
  primary: {
    main: '#008080',
    light: '#00b3b3',
    dark: '#005959',
    contrastText: '#fafafa',
  },
  secondary: {
    main: '#0A1A2B',
    light: '#3a4a5d',
    dark: '#1a2a3d',
    contrastText: '#fafafa',
  },
  background: {
    default: '#0A1A29',
    paper: '#0c1f31',
  },
  text: {
    primary: '#d6deeb',
    secondary: '#aeb7c3',
  },
  border: '#222c3a',
  ring: '#00a3a3',
  sidebar: {
    background: '#0c1f31',
    foreground: '#d6deeb',
    primary: '#00a3a3',
    primaryForeground: '#fafafa',
    accent: '#14365c',
    accentForeground: '#f2f5f9',
    border: '#1a3a5d',
    ring: '#00c2c2',
  },
  buttonPrimaryHover:{
    main:'#0080FF'
  },
  action: {
    disabled: '#A1A1A1',
    disabledBackground: '#0A1A29',
  }
};

export function getStudioTokens(mode: ThemeMode): StudioThemeTokens {
  return mode === 'dark' ? darkTokens : lightTokens;
} 